import { Text, Box, Heading, Image, Button, Flex, Grid, GridItem, Icon } from "@chakra-ui/react";
import query_tool from './images/querytool.png'
import uploadDataset from "./images/uploadDataset.png"
import BgImage from './images/BgImage.jpg'
import DescriptionCard from "./DescriptionCard";
import DescriptionCardWP from "./DescriptionCardWP";
import { Link, useNavigate } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import ResilienceActorsFirms from "./images/UserGuestImage/Resilience of Actors_Firm.jpg";
import ResilienceActorsPublicSector from "./images/UserGuestImage/Resilience_of_Actors_PublicSector.jpg";
import ResilienceActorsHouseholds from "./images/UserGuestImage/Resilience_of_Actors_Households.jpg";
import InnovationEcosystems from "./images/UserGuestImage/Enabling_Strategies_Innovation_ecosystems.jpg";
import SustainableFinance from "./images/UserGuestImage/Enabling_Strategies_Sustainable_finance.jpg";
import LowCarbonPolices from "./images/UserGuestImage/Enabling_Strategies_Low_carbon_polices.jpg";
import TerritorialSustainability from "./images/UserGuestImage/Sustainability_Territorial_Sustainability.jpg";
import SocialSustainability from "./images/UserGuestImage/Sustainability_Social_Sustainability.jpg";
import { useTranslation } from "react-i18next";
import { MdLogin } from 'react-icons/md';
import StatView from "./StatView";

import StatImg01 from "./images/StatisticalGifs/total_dataset_number.png";
import StatImg02 from "./images/StatisticalGifs/visibility_pie.png";
import StatImg03 from "./images/StatisticalGifs/ds_timeseries.png";
import StatImg04 from "./images/StatisticalGifs/category_histogram.png";

import servicesImg from "./images/UserGuestImage/services.jpeg";
import catalogImg from "./images/UserGuestImage/catalog.jpeg";
import dashboardImg from "./images/UserGuestImage/dashboard.jpeg";

import GridStatView from "./GridStatView";
import RequestAcessCard from "./ui/RequestAccessCard";

export default function HomeGuest() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const goToAmeliaDP = () => {
    sessionStorage.setItem("username", "anonymous");
    navigate('/login')
    window.location.reload()
  }

  const smallStatImgs = [StatImg01, StatImg03, StatImg02, StatImg04];
  const titles = ["Uploaded Datasets", "Number of uploaded datasets over time", "Visibility Pie", "Categories Histogram"]
  const gridConfig = [
    { colSpan: 1, rowSpan: 1, ratio: 1 },     // Normal size for image 1
    { colSpan: 1, rowSpan: 1, ratio: 1 },     // Normal size for image 2
    { colSpan: 1, rowSpan: 1, ratio: 1.15 },  // Slightly larger for pie chart (image 3)
    { colSpan: 1, rowSpan: 1, ratio: 1 },     // Normal size for image 4
  ];
  return (
    <Box h="100%" w="100%" maxW="100vw" bgColor="#f6f3ec" overflowY="auto" overflowX="hidden">
      <Box flex={1} bg="#003b47" color="white" p={5} borderRadius="lg" margin={"2%"} mt={4}>
        <Flex justify="space-between" mb={4}>
          <Box maxW="100%">

            <Heading as="h2" fontSize="3xl" mb={4}>
              {t('guestArea.guestHome.publicArea')}
            </Heading>
            <Text fontSize="lg">
              {t('guestArea.guestHome.publicAreaDescription')}

            </Text>
          </Box>
          {/* Pulsante "Vedi Tutti" */}

        </Flex>

      </Box>
      {/* PUBLIC SERVICES */}
      <Box color="#003b47" p={10} borderRadius="lg" margin={"2%"} mt={-8}>
        <Flex justify="center" align="center" mb={2} >
          <Box maxW="50%">
            <Heading as="h2" fontSize="3xl" mb={-1}>
              <Text>
                PUBLIC SERVICES
              </Text>
            </Heading>
          </Box>
        </Flex>

        {/* Griglia con le aree */}
        <Grid templateColumns="repeat(3, 1fr)" gap={6} mt={0}>
          {/* Card Area 01 */}
          <GridItem bg="white" borderRadius="lg" position="relative">
           <RequestAcessCard/>
          </GridItem>

          {/* Card Area 02 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={"Dataset Catalog"}
              height={"100%"}
              ImgUrl={catalogImg}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => navigate("/datasetGuest")}
            />
          </GridItem>

          {/* Card Area 03 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={"Dashboards"}
              ImgUrl={dashboardImg}
               height={"100%"}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/dashboardGuest") }}
            />
          </GridItem>
        </Grid>
      </Box>
      {/* FINE PUBLIC SERVICES */}
      {/* INIZIO STATISTICAL AREA */}
      <Box color="#003b47" p={6} borderRadius="lg" width="100%" mt={-8}>
        <Heading as="h2" fontSize="3xl" textAlign="center" mb={2}>
          STATISTICAL DATA
        </Heading>
        <Box display="flex" width="100%" maxW="1400px" mx="auto" flexDirection={["column", "column", "row"]}>
          <Box bg="#f6f3ec" borderRadius="lg" p={6} pt={3} width={["100%", "100%", "25%"]} minH="100%" display="flex" flexDirection="column" justifyContent="flex-start" alignItems="center" mr={[0, 0, 2]} mb={[4, 4, 0]} mt={0} border="2px solid" borderColor="#0b4e5a">
            <Text fontSize="xl" fontWeight="bold" textAlign="center" mb={4} color={"#003b47"}>
              Statistical Overview
            </Text>
            <Text fontSize="md" textAlign="justify" color={"#003b47"}>
              Explore key insights derived from our dataset statistics. This includes dataset distribution, visibility trends, and time series analysis, helping you make data-driven decisions efficiently. In this view, it is possible to access the Number of Dataset Growth compared to the previous month. A timeseries showing the growth of the uploaded dataset number over a longer time range. A Visibility Pie retrieves data in percentage related to the diversity of Dataset Visibility, at the time divided into Public (Accessible to every user), Private (Strictly accessible to the user who uploaded the dataset), General (Matter of Public Interest). A Category Histogram shows the number of uploaded data set by distinguishing them by Categories.
            </Text>
          </Box>
          <Box flex="1">
            <Box
              bg="#f6f3ec"
              borderRadius="lg"
              p={4}
              height={["auto", "auto", "auto"]}
              border="2px solid"
              borderColor="#0b4e5a"
            >
              <Box mb={4}>
                <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                  <GridItem>
                    <Text fontSize="md" fontWeight="bold" textAlign="center" color="#0b4e5a">
                      {titles[0]}
                    </Text>
                  </GridItem>
                  <GridItem>
                    <Text fontSize="md" fontWeight="bold" textAlign="center" color="#0b4e5a">
                      {titles[1]}
                    </Text>
                  </GridItem>
                </Grid>
                <Box height="210px" mt={2} mb={4}> {/* Reduced height from 250px to 230px */}
                  <GridStatView
                    images={[smallStatImgs[0], smallStatImgs[1]]}
                    gridConfig={[gridConfig[0], gridConfig[1]]}
                    titles={[titles[0], titles[1]]}
                  />
                </Box>
              </Box>
              <Box>
                <Grid templateColumns="repeat(2, 1fr)" gap={2}>
                  <GridItem>
                    <Text fontSize="md" fontWeight="bold" textAlign="center" color="#0b4e5a">
                      {titles[2]}
                    </Text>
                  </GridItem>
                  <GridItem>
                    <Text fontSize="md" fontWeight="bold" textAlign="center" color="#0b4e5a">
                      {titles[3]}
                    </Text>
                  </GridItem>
                </Grid>
                <Box height="230px" mt={2}> {/* Reduced height from 250px to 230px */}
                  <GridStatView
                    images={[smallStatImgs[2], smallStatImgs[3]]}
                    gridConfig={[gridConfig[2], gridConfig[3]]}
                    titles={[titles[2], titles[3]]}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      {/* <hr style={{ borderTop: '2px solid #0b4e5a' }} /> */}
      <Box color="#003b47" p={10} borderRadius="lg" margin={"2%"} mt={-8}>
        <Flex justify="center" align="center" mb={2} >
          <Box maxW="50%">
            <Heading as="h2" fontSize="3xl" mb={0}>
              {t('guestArea.guestHome.resilienceOfActors')}
            </Heading>
          </Box>
        </Flex>

        {/* Griglia con le aree */}
        <Grid templateColumns="repeat(3, 1fr)" gap={6}>
          {/* Card Area 01 */}
          <GridItem bg="white" borderRadius="lg" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.firms')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.developESGBenchmarks')}</li>
                  <li>{t('guestArea.guestHome.firmsSectorsValueChain')}</li>
                  <li>{t('guestArea.guestHome.activateCircularEconomy')}</li>
                  <li>{t('guestArea.guestHome.increaseFirmResilience')}</li>
                </ul>
              }
              ImgUrl={ResilienceActorsFirms}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalFirms") }}
            />
          </GridItem>

          {/* Card Area 02 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.publicSector')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.capacityBuilding')}</li>
                  <li>{t('guestArea.guestHome.effectivenessPublicServices')}</li>
                  <li>{t('guestArea.guestHome.sustainablePublicFinance')}</li>
                  <li>{t('guestArea.guestHome.publicPolicyDesignEvaluation')}</li>
                  <li>{t('guestArea.guestHome.measurePAEfficacy')}</li>
                </ul>
              }
              ImgUrl={ResilienceActorsPublicSector}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalPublicSector") }}
            />
          </GridItem>

          {/* Card Area 03 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.households')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left', textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.resilienceToShocks')}</li>
                  <li>{t('guestArea.guestHome.riskDebtSustainability')}</li>
                  <li>{t('guestArea.guestHome.humanCapitalEcologicalAwareness')}</li>
                  <li>{t('guestArea.guestHome.financialLiteracy')}</li>
                  <li>{t('guestArea.guestHome.teleworkingPoliciesInequality')}</li>
                </ul>
              }
              ImgUrl={ResilienceActorsHouseholds}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalHouseholds") }}
            />
          </GridItem>
        </Grid>
      </Box>

      {/* FINE STATISTICAL AREA */}

      <Box color="#003b47" p={10} borderRadius="lg" margin={"2%"} mt={-10}>
        <Flex justify="center" align="center" mb={0} >
          <Box maxW="50%">
            <Heading as="h2" fontSize="3xl" mb={2}>
              {t('guestArea.guestHome.enablingStrategies')}
            </Heading>
          </Box>
        </Flex>

        {/* Griglia con le aree */}
        <Grid templateColumns="repeat(3, 1fr)" gap={6}>
          {/* Card Area 01 */}
          <GridItem bg="white" borderRadius="lg" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.sustainableFinance')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.makePublicDebtSustainable')}</li>
                  <li>{t('guestArea.guestHome.capitalFlowsSustainableInvestments')}</li>
                  <li>{t('guestArea.guestHome.financialInstitutionsProtectCommunities')}</li>
                  <li>{t('guestArea.guestHome.standardsForESG')}</li>
                </ul>
              }
              ImgUrl={SustainableFinance}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalSustainableFinance") }}
            />
          </GridItem>

          {/* Card Area 02 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.innovationEcosystems')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.innovateFosterCircularEconomy')}</li>
                  <li>{t('guestArea.guestHome.increaseWasteToResource')}</li>
                  <li>{t('guestArea.guestHome.increaseRepairReuse')}</li>
                  <li>{t('guestArea.guestHome.efficientTransferInnovation')}</li>
                </ul>
              }
              ImgUrl={InnovationEcosystems}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalInnovationEcosystem") }}
            />
          </GridItem>

          {/* Card Area 03 */}
          <GridItem bg="white" borderRadius="lg" color="#003b47" position="relative">
            <DescriptionCardWP
              title={t('guestArea.guestHome.lowCarbonPolicies')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '1rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.fightEnergyPoverty')}</li>
                  <li>{t('guestArea.guestHome.limitDistributionalImpactTariffs')}</li>
                  <li>{t('guestArea.guestHome.increaseEnergyEfficiency')}</li>
                  <li>{t('guestArea.guestHome.developEnergyCommunity')}</li>
                  <li>{t('guestArea.guestHome.fosterGreenProcurement')}</li>
                </ul>
              }
              ImgUrl={LowCarbonPolices}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalLowCarbon") }}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box color="#003b47" p={10} borderRadius="lg" margin={"2%"} mt={-10}>
        <Flex justify="center" align="center" mb={0} >
          <Box maxW="50%">
            <Heading as="h2" fontSize="3xl" mb={2}>
              {t('guestArea.guestHome.sustainability')}
            </Heading>
          </Box>
        </Flex>
        <Flex w="100%" gap={3} >
          {/* First DescriptionCard */}
          <Box flex={1} marginLeft={"2%"}>
            <DescriptionCardWP
              title={t('guestArea.guestHome.territorialSustainability')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '0rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.infrastructures')}</li>
                  <li>{t('guestArea.guestHome.smartMobility')}</li>
                  <li>{t('guestArea.guestHome.dealMarginalAreas')}</li>
                  <li>{t('guestArea.guestHome.favorDigitalNetworks')}</li>
                </ul>
              }
              ImgUrl={TerritorialSustainability}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalTerritorialSustainability") }}
            />
          </Box>

          {/* Second DescriptionCard */}
          <Box flex={1} marginRight={"2%"} w="50%">
            <DescriptionCardWP
              title={t('guestArea.guestHome.socialSustainability')}
              description={
                <ul style={{ listStyleType: 'disc', paddingLeft: '0rem', margin: 0, textAlign: 'left' }}>
                  <li>{t('guestArea.guestHome.favorInclusiveCommunities')}</li>
                  <li>{t('guestArea.guestHome.deviseStrategiesMigration')}</li>
                  <li>{t('guestArea.guestHome.reduceCrime')}</li>
                </ul>
              }
              ImgUrl={SocialSustainability}
              textButton={t('guestArea.guestHome.portalAccess')}
              onClick={() => { navigate("/portalSocialSustainability") }}
            />
          </Box>
        </Flex>
      </Box>
      <Box
        display="flex"
        w="98%"
        marginLeft={"1%"}
        marginRight={"1%"}


      >
        {/* Testo a sinistra */}

      </Box>

      <br />

      {/* <Flex w="100%" gap={2} mt={-8}>
        <Box flex={1} marginLeft={"2%"} >
          <DescriptionCard
            title="Query Tool"
            description={t('guestArea.guestHome.queryToolDescription')}
            buttonDescription={t('guestArea.guestHome.buttonDescription.description')}
            ImgUrl={query_tool}
            path='/query'
          />
        </Box>

        <Box flex={1} marginRight={"2%"} w="50%">
          <DescriptionCard
            title={t('guestArea.guestHome.uploadDataset')}
            description=""
            buttonDescription={t('guestArea.guestHome.buttonDescription.description')}
            ImgUrl={uploadDataset}
            path='/dataset'
            borderRadius="lg"
          />
        </Box>

      </Flex> */}
      <Box bg="#003b47" color="white" p={10} borderRadius="lg" margin={"2%"} mt={0}>
        {/* Titolo principale */}
        <Flex justify="space-between" mb={8}>
          <Box maxW="50%">
            <Text fontSize="sm" color="#b4dbdb" mb={2}>
              {t('guestArea.guestHome.titleActivitiesPlatform')}
            </Text>
            <Heading as="h2" fontSize="3xl" mb={4}>
              {t('guestArea.guestHome.ameliaOffers')}
            </Heading>
            <Text fontSize="lg">
              {t('guestArea.guestHome.ameliaDescription')}
            </Text>
          </Box>
          {/* Pulsante "Vedi Tutti" */}
          <Button variant="outline" borderColor="#b4dbdb" color="#b4dbdb" borderRadius="full" _hover={{ bg: "#b4dbdb", color: "#003b47" }} onClick={goToAmeliaDP}>
            {t('guestArea.guestHome.goToPlatform')}
          </Button>
        </Flex>

        {/* Griglia con le aree */}
        <Grid templateColumns="repeat(3, 1fr)" gap={6}>
          {/* Card Area 01 */}
          <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
            <Heading as="h4" size="md" mb={4}>
              {t('guestArea.guestHome.tools')}
            </Heading>
            <Text fontWeight="bold" mb={2}>{t('guestArea.guestHome.questionWhatCanIUse')}</Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - {t('guestArea.guestHome.queryTool')}
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - {t('guestArea.guestHome.statisticalTool')}
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Jupyter
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Zeppelin
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Superset
            </Text>
            {/* Icona freccia */}

          </GridItem>

          {/* Card Area 02 */}
          <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
            <Heading as="h4" size="md" mb={4}>
              {t('guestArea.guestHome.catalog')}
            </Heading>
            <Text fontWeight="bold" mb={2}>{t('guestArea.guestHome.questionWhatCanIObserve')}</Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Datasets
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - {t('guestArea.guestHome.stagingArea')}
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - {t('guestArea.guestHome.results')}
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - {t('guestArea.guestHome.processing')}
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Dashboards
            </Text>
            {/* Icona freccia */}

          </GridItem>

          {/* Card Area 03 */}
          <GridItem bg="white" borderRadius="lg" p={6} color="#003b47" position="relative">
            <Heading as="h4" size="md" mb={4}>
              {t('guestArea.guestHome.supportedDataFormats')}
            </Heading>
            <Text fontWeight="bold" mb={2}>{t('guestArea.guestHome.questionWhatCanIUpload')}</Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Shapefile
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Csv
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Json
            </Text>
            <Text href="#" color="#00686b" mb={1} display="block">
              - Excel
            </Text>
            {/* Icona freccia */}

          </GridItem>
        </Grid>
      </Box>
    </Box>


  )





}   